import { useCallback, useEffect, useMemo } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useRisingEdgeEffect } from 'src/clientLib/hooks'
import { RtkDropzone } from 'src/components/RtkDropzone'
import { clearUserFiles } from 'src/redux/services/ubem'
import { AsyncTask } from 'src/redux/slices/async-processing/consts'
import { startAsyncTask } from 'src/redux/slices/async-processing/reducers'
import { useNavigationEffect } from 'src/redux/slices/navigation/hooks'
import { Entrypoint } from 'src/redux/slices/umibuilder/consts'
import { uploadBaseGisFile } from 'src/redux/slices/umibuilder/endpoints'
import { clearAllData } from 'src/redux/slices/umibuilder/reducers'
import {
  isLoading,
  selectEntrypoint,
  selectGeoJSON
} from 'src/redux/slices/umibuilder/selectors'

import Button from '@material-ui/core/Button'
import Grid from '@material-ui/core/Grid'

// TODO: Add warnings for incomplete shpfile stuff

const UploadPage: React.FC = () => {
  const dispatch = useDispatch()
  const entrypoint = useSelector(selectEntrypoint)
  const hasGeoJSON = useSelector(selectGeoJSON)
  const loading = useSelector(isLoading)
  const { isSuccess: isUploadSuccess } = useSelector(uploadBaseGisFile.select(entrypoint))

  const processFiles = useCallback(() => {
    dispatch(startAsyncTask({ endpoint: AsyncTask.processBaseGis }))
  }, [dispatch])

  // Automatically advance UIO files
  useRisingEdgeEffect({
    callback: processFiles,
    condition: isUploadSuccess && entrypoint === Entrypoint.uio,
  })

  // Go to tab if geojson transitions from null
  useNavigationEffect({ destination: 'keyfields', condition: hasGeoJSON })

  const [triggerClearFiles] = clearUserFiles.useMutation()

  // Clear user files on mount
  useEffect(() => {
    // triggerClearFiles()
    dispatch(clearAllData())
  }, [triggerClearFiles, dispatch])

  const dropzoneProps = useMemo(
    () => ({
      label: `${entrypoint === Entrypoint.uio ? '.UIO Exchange' : 'GIS'} File Upload`,
      rows: 4,
      formData: {
        entrypoint,
      },
      mutation: uploadBaseGisFile.useMutation,
      index: entrypoint,
      skipReset: false,
      maxFiles: entrypoint === Entrypoint.uio ? 1 : 6,
      accept:
        entrypoint === Entrypoint.uio
          ? '.uio'
          : 'application/zip, .geojson, application/json, application/x-zip-compressed, multipart/x-zip,' +
            ' "multipart/form-data", .cpg, .dbf, .prj, .qpj, .shp, .shx, .gdb',
    }),
    [entrypoint],
  )

  return (
    <Grid container justifyContent='center' alignItems='center' spacing={3}>
      <Grid item>
        <RtkDropzone {...dropzoneProps} />
      </Grid>
      <Button disabled={loading} variant='outlined' onClick={processFiles}>
        Open Files
      </Button>
    </Grid>
  )
}

export default UploadPage
